import React from "react";
import { FormGroup } from "reactstrap";

import "./CustomSelect.scss";
import Select from "react-select";

const CustomSelect = ({
  className,
  onChange,
  placeholder,
  options,
  value,
  isLoading,
  filterOption
}) => {
  return (
    <div className="search-box chat-search-box selectTransferChat">
      <div className="position-relative">
        <FormGroup className="select2-container">
          <Select
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            classNamePrefix="select2-selection"
            className={className}
            placeholder={placeholder}
            options={options}
            onChange={onChange}
            value={value}
            isLoading={isLoading}
            menuIsOpen={true}
            isSearchable={true}
            filterOption={filterOption}
            maxMenuHeight={250}
          />
        </FormGroup>
        <i className="bx bx-search-alt search-icon"></i>
      </div>
    </div>
  );
};
export default CustomSelect;
